module.exports = __webpack_public_path__ + "static/multiples-preview-4c563d87962d72af0c564bd0682cd4f2.png";